<template>
  <div class="intercept-container">
    <img src="https://static.ndmicro.com/tmd/landing/images/img_shixiao%402x.png">
    <p>链接已失效</p>
  </div>
</template>
<script>
export default {
  name: 'intercept',
  created () {
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.intercept-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  padding-top: 500px;
  img {
    width:160px;
    height:171px;
  }
  p {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 36px;
    margin-top: 30px;
  }
}
</style>